module.exports = __webpack_public_path__ + "media/images/cannot-redeem-08e1c4830ee5b2675fa1477057a2e62d.svg";